import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ProjectsIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.59546 1H14.0753L18.5621 5.48685V17.9046C18.5621 18.5123 18.0669 19 17.4667 19H2.59546C1.98771 19 1.5 18.5048 1.5 17.9046V2.09546C1.5 1.48771 1.99521 1 2.59546 1Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0752 1V4.37641C14.0752 4.98416 14.5704 5.47185 15.1707 5.47185H18.5621"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.77344 4.37646H9.17571"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.77344 6.44715H9.17571"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5583 8.5H13.4949C13.0806 8.5 12.7446 8.83594 12.7446 9.2503V11.3137C12.7446 11.7281 13.0806 12.064 13.4949 12.064H15.5583C15.9727 12.064 16.3086 11.7281 16.3086 11.3137V9.2503C16.3086 8.83594 15.9727 8.5 15.5583 8.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3137 13.275H8.2503C7.83594 13.275 7.5 13.6109 7.5 14.0253V16.0887C7.5 16.5031 7.83594 16.839 8.2503 16.839H10.3137C10.7281 16.839 11.064 16.5031 11.064 16.0887V14.0253C11.064 13.6109 10.7281 13.275 10.3137 13.275Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6418 12.5L14.6418 14.841C14.6418 15.1411 14.3942 15.3887 14.0941 15.3887L11.288 15.3887"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ProjectsIcon.displayName = 'ProjectsIcon';
